import { Info } from "lucide-react";
import { Tooltip } from "@mantine/core";
import React, { ReactNode } from "react";

interface CustomTooltipProps {
  label: string;
  icon?: ReactNode;
  onMouseEnterCallBack?: () => void;
}

const CustomTooltip: React.FC<CustomTooltipProps> = ({
  label,
  icon,
  onMouseEnterCallBack,
}) => (
  <Tooltip
    label={label}
    wrapLines
    width={360}
    onMouseEnter={onMouseEnterCallBack}
  >
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
      }}
    >
      {icon || <Info size={16} />}
    </div>
  </Tooltip>
);

export default CustomTooltip;
